<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <IntegrationDataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :actionsComponent="componentForActions"
      :delete_url="delete_url"
      :urls="urls"
    />
  </div>
</template>

<script>
import IntegrationDataTable from "@/own/components/datahub/integrations2/IntegrationDataTable.vue";
import AddItem from "@/own/components/datahub/integrations2/platformStatusProcessing/AddItem.vue";
import EditItem from "@/own/components/datahub/integrations2/platformStatusProcessing/EditItem.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PER_PAGE,
  SET_TABLE_SORT_BY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/platformStatusProcessAction.module";
import DataTableActionSelectorNew from "@/own/components/DataTableActionSelectorNew.vue";
export default {
  name: "platformStatusProcessAction",
  props: ["integration"],
  components: { IntegrationDataTable },
  data: () => ({
    componentForEditing: EditItem,
    componentForAdding: AddItem,
    componentForActions: DataTableActionSelectorNew,
    delete_url: `/validations/datahub/platform_status_processing_actions/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORT_BY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PER_PAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getPlatformStatusProcessActionTableFilters",
      getTableState: "getPlatformStatusProcessActionTableState",
      getTableData: "getPlatformStatusProcessActionTableData",
      getTableHeaders: "getPlatformStatusProcessActionTableHeaders",
      getTableProperties: "getPlatformStatusProcessActionTableProperties",
      getTableExportUrl: "getPlatformStatusProcessActionExportUrl",
      getTablePermissions: "getPlatformStatusProcessActionTablePermissions",
    },
    urls: {
      // status: `/order_management/subscriptions/status`,
      delete: `/datahub/integration_order_status/destroy`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {
        integration_id: this.integration.id,
      });
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {
        integration_id: this.integration.id,
      });
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
